import * as React from 'react';
import styled from 'styled-components';

import { animated, useSpring } from 'react-spring';

const PageStyle = styled(animated.div)`
  width: 100%;
  margin-top: 66px;
`;

export const Page: React.FC = ({ children }) => {
  const animateProps = useSpring({
    from: {
      opacity: 0,
    },
    to: {
      opacity: 1,
    },
  });

  React.useEffect(() => {
    if (typeof window !== 'undefined') {
      window.scroll(0, 0);
    }
  }, []);

  return <PageStyle style={animateProps}>{children}</PageStyle>;
};
